import React from 'react'

import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'

import { BOARD } from './accents'

/**
 * Green ghost "add row" button used inside node bodies.
 */
const AddButton = (props: { label?: string; onClick: () => void }) => (
  <Button
    fullWidth
    onClick={props.onClick}
    size="small"
    startIcon={<Icon name="Add" sx={{ fontSize: '15px' }} />}
    variant="text"
    sx={{
      borderRadius: '9px',
      color: BOARD.signalGreenDark,
      fontFamily: BOARD.fontBody,
      fontSize: '12.5px',
      fontWeight: 600,
      '&:hover': {
        backgroundColor: '#DCFCE7'
      }
    }}
  >
    {props.label ?? 'Lägg till'}
  </Button>
)

export default AddButton
